import "../reportDashboard.scss";

// Shared page-forward/back control for every server-paged list in this feature that
// isn't a full DataGrid footer (GridTable/DashboardTable already have their own built
// in) — RecordModal's `cards`/`chips` sections (Reporter Case History, credential-type
// holders, linked cases) and IncidentsSection's case timeline all reuse this one
// component instead of hand-rolling their own Prev/Next row.
//
// `page` is 0-indexed, matching usePaginatedList's convention, so `page * pageSize`
// lines up directly with the API's own offset math without an off-by-one translation
// at every call site.
//
// Renders nothing once the whole result set already fits on a single page — a Prev/Next
// row under a 6-row list that can never have a second page is just visual noise, and
// callers can render this unconditionally without their own `rowCount > pageSize` guard.
const Pager = ({ page, pageSize, rowCount, onPageChange, loading }) => {
  if (rowCount == null || rowCount <= pageSize) return null;

  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, rowCount);
  const isFirstPage = page <= 0;
  const isLastPage = end >= rowCount;

  return (
    <div className="rdPager">
      <span className="rdPager__summary">
        Showing {start}-{end} of {rowCount}
      </span>
      <div className="rdPager__controls">
        <button
          type="button"
          className="rdPager__btn"
          disabled={isFirstPage || loading}
          onClick={() => onPageChange(page - 1)}
        >
          Prev
        </button>
        <button
          type="button"
          className="rdPager__btn"
          disabled={isLastPage || loading}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pager;
